module.exports = __webpack_public_path__ + "static/media/man.ce79bd09.jpg";